import EnglishIcon from "assets/icons/english.svg?react";
import EmailIcon from "assets/icons/email.svg?react";
import styles from "./CourseItem.module.css";

const CourseItem = ({ course, isCurrent, setIsModalOpen, setEmailTo }) => {
    return (
        <li
            className={styles.courseItem}
            data-testid={`course-item-${course.name.toLowerCase().replace(/\s/g, "-")}`}
        >
            <div className={styles.courseItemInfo}>
                <div className={styles.courseItemIcon}>
                    <EnglishIcon />
                </div>
                <div className={styles.courseItemDetails}>
                    <h4 className={styles.courseItemName}>{course.name}</h4>
                    {course.teachers.length < 1 ? (
                        <p className={styles.courseItemTeachers}>
                            <EmailIcon /> No teachers assigned
                        </p>
                    ) : (
                        course.teachers.map((teacher) => (
                            <p
                                className={styles.courseItemTeachers}
                                key={teacher.email}
                            >
                                <EmailIcon /> {teacher.name}
                            </p>
                        ))
                    )}
                </div>
            </div>
            <div className={styles.courseItemActions}>
                {isCurrent && (
                    <a
                        onClick={() => {
                            setIsModalOpen(true);
                            setEmailTo(
                                course.teachers
                                    .map((teacher) => teacher.emailAddress)
                                    .join(", "),
                            );
                        }}
                    >
                        Contact Teacher
                    </a>
                )}
                <a href={course.link} target="_blank">
                    View Course
                </a>
            </div>
        </li>
    );
};

export default CourseItem;
